import React, { FC, ReactNode } from 'react'
import { Card } from 'transfix-ui/components/Card'
import { Box, Typography } from 'transfix-ui/core'

interface IUserSettingsCardProps extends JSX.ElementChildrenAttribute {
  title: ReactNode
  subtitle?: ReactNode
}

export const UserSettingsCard: FC<IUserSettingsCardProps> = ({ children, subtitle, title }) => {
  return (
    <div className='flex justify-center mt6'>
      <Card className='col-lg-8'>
        <div className='pa4'>
          <div className='body-large'>{title}</div>
          {subtitle && (
            <Box pt={2} pb={2}>
              <Typography variant='body1' component='span'>
                {subtitle}
              </Typography>
            </Box>
          )}
          {children}
        </div>
      </Card>
    </div>
  )
}
